import { useContext, useMemo } from 'react';
import { AgentProgressContext } from './context';
import type { CardState, TimelineNode } from './interfaces';
import {
  attachReasoningToToolCalls,
  buildTimeline,
  collapseRepeatedToolCalls,
  deriveCardState,
  flattenNodes,
  flattenTimelineTree,
  groupParallelNodes,
} from './utils.timeline';

interface AgentProgressTimelineResult {
  timeline: TimelineNode[];
  cardState: CardState | undefined;
}

export function useAgentProgressTimeline(): AgentProgressTimelineResult {
  const progress = useContext(AgentProgressContext);

  return useMemo(() => {
    if (!progress) return { timeline: [], cardState: undefined };
    const timeline = buildTimeline(progress);
    // Run the same pipeline the renderer uses so deriveCardState sees collapsed nodes.
    const collapsed = collapseRepeatedToolCalls(groupParallelNodes(attachReasoningToToolCalls(flattenNodes(timeline))));
    const flat = flattenTimelineTree(collapsed);
    const cardState = deriveCardState(progress, flat);
    return { timeline, cardState };
  }, [progress]);
}
